// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solid-pod-provider {
  position: relative;
  width: 100%;
  min-height: auto;
  padding-bottom: 0;
}

.solid-pod-provider__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.spp-shell {
  width: 100%;
  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 230px);
  padding: 18px;
  background: #ffffff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.spp-account-card {
  width: 100%;
  max-width: none;
  display: grid;
  gap: 22px;
}

.spp-account-card__title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
}

.spp-account-card__title h2 {
  margin: 0;
  font-size: 22px;
  line-height: 1.15;
  color: var(--text);
}

.spp-action,
.spp-iconBtn,
.spp-deleteIconBtn,
.spp-btn {
  font: inherit;
}

.spp-status,
.spp-empty {
  color: var(--muted);
  font-weight: 800;
}

.spp-empty {
  min-height: 96px;
  display: grid;
  place-items: center;
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  background: #f8fafc;
}

.spp-warning {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #fed7aa;
  background: #fff7ed;
  color: #9a3412;
}

.spp-warning--subtle {
  border-color: #dbeafe;
  background: #f8fbff;
  color: #475569;
}

.spp-warning svg {
  margin-top: 2px;
}

.spp-warning div {
  display: grid;
  gap: 5px;
}

.spp-warning strong {
  color: #7c2d12;
}

.spp-warning--subtle strong {
  color: #334155;
}

.spp-login {
  display: grid;
  gap: 14px;
  padding: 18px;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  background: #f8fbff;
}

.spp-login__head h3 {
  margin: 0;
  color: var(--text);
  font-size: 20px;
  line-height: 1.2;
}

.spp-login__head p {
  margin: 7px 0 0;
  color: var(--muted);
}

.spp-login__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 280px));
  gap: 12px;
}

.spp-login__grid label {
  display: grid;
  gap: 5px;
}

.spp-login__grid label > span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.spp-login input[type="email"],
.spp-login input[type="password"] {
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  color: var(--text);
  background: #ffffff;
  border: 1px solid var(--border);
  border-radius: 12px;
  outline: none;
}

.spp-login input[type="email"]:focus,
.spp-login input[type="password"]:focus {
  border-color: #b9d4ff;
  box-shadow: 0 0 0 4px var(--ring);
}

.spp-login__check {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-weight: 700;
}

.spp-login__check input {
  accent-color: var(--primary);
}

.spp-login__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.spp-login__error {
  color: var(--danger);
  font-weight: 800;
}

.spp-login__note {
  color: #475569;
  font-weight: 700;
}

.spp-overview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.spp-metric {
  min-width: 0;
  min-height: 104px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr);
  align-items: center;
  gap: 8px 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #f8fbff;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);
}

.spp-metric svg {
  grid-column: 1;
  grid-row: 1;
  width: 22px;
  height: 22px;
  color: var(--primary);
}

.spp-metric span {
  grid-column: 2;
  grid-row: 1;
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.spp-metric strong {
  grid-column: 1 / -1;
  grid-row: 2;
  color: var(--text);
  font-size: 28px;
  line-height: 1;
}

.spp-contentGrid {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 1fr);
  gap: 28px 24px;
  align-items: stretch;
}

.spp-contentGrid .spp-section:nth-child(3) {
  grid-column: 1 / -1;
}

.spp-section {
  min-width: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  align-content: start;
  gap: 14px;
  width: 100%;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 16px;
  background: var(--card);
}

.spp-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 50px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.spp-section__titleBlock {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.spp-section__icon {
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: #eaf2ff;
  color: var(--primary);
}

.spp-section h3 {
  margin: 0;
  color: var(--text);
  font-size: 20px;
  line-height: 1.2;
}

.spp-section p {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 13px;
  font-weight: 700;
}

.spp-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 12px;
  border: 1px solid #dbe8ff;
  border-radius: 14px;
  background: var(--primary-ghost);
  color: var(--primary);
  white-space: nowrap;
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.spp-action:hover {
  background: #dbeafe;
}

.spp-list {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
}

.spp-list li {
  min-width: 0;
  display: flex;
}

.spp-list li > * {
  width: 100%;
}

.spp-item {
  position: relative;
  min-width: 0;
  min-height: 142px;
  display: grid;
  align-content: start;
  gap: 13px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);
}

.spp-item--token {
  min-height: 166px;
  padding-right: 58px;
}

.spp-item__main {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.spp-item__label,
.spp-owner-list > span:first-child {
  color: var(--muted);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.spp-item strong {
  min-width: 0;
  color: var(--text);
  overflow-wrap: anywhere;
}

.spp-inlineLink {
  width: 100%;
  min-width: 0;
  display: block;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--primary);
  font: inherit;
  font-weight: 800;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
  overflow-wrap: anywhere;
}

.spp-inlineLink:hover {
  text-decoration: underline;
}

.spp-owner-list {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.spp-owner {
  color: #0f766e;
  font-size: 0.9rem;
}

.spp-deleteIconBtn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 1px solid #fecaca;
  border-radius: 12px;
  background: #fff1f2;
  color: var(--danger);
  cursor: pointer;
}

.spp-deleteIconBtn:hover {
  background: #fee2e2;
}

.spp-modalOverlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 22px;
  background: rgba(15, 23, 42, 0.46);
  backdrop-filter: blur(8px);
}

.spp-modal {
  background: #ffffff;
  border: 1px solid #dbe3f3;
  border-radius: 24px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.3);
  overflow: hidden;
}

.spp-modal--external {
  width: min(1180px, 100%);
  height: min(820px, calc(var(--dataspace-scaled-vh, 100vh) - 80px));
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}

.spp-modal--native {
  width: min(560px, 96vw);
  max-height: min(720px, 92vh);
  overflow: auto;
}

.spp-modal__head {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 20px 22px;
  color: #ffffff;
  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 55%, #1d4ed8 100%);
}

.spp-modal__eyebrow {
  display: block;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  opacity: 0.86;
  overflow-wrap: anywhere;
  text-transform: uppercase;
}

.spp-modal h2 {
  margin: 5px 0 0;
  color: #ffffff;
  font-size: 22px;
  line-height: 1.15;
}

.spp-modal__actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spp-iconBtn {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  cursor: pointer;
  text-decoration: none;
}

.spp-iconBtn:hover {
  background: rgba(255, 255, 255, 0.22);
}

.spp-iconBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

.spp-modal__body {
  position: relative;
  min-height: 0;
  background: #f8fafc;
}

.spp-modal__body iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #ffffff;
}

.spp-nativeForm {
  display: grid;
  gap: 14px;
  padding: 20px 22px 22px;
}

.spp-nativeForm label {
  display: grid;
  gap: 6px;
}

.spp-nativeForm label > span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.spp-nativeForm input[type="text"],
.spp-nativeForm input[type="url"],
.spp-nativeForm select {
  width: 100%;
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  color: #0f172a;
  outline: none;
}

.spp-nativeForm input[type="text"]:focus,
.spp-nativeForm input[type="url"]:focus,
.spp-nativeForm select:focus {
  border-color: #b9d4ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.spp-nativeForm select {
  appearance: none;
}

.spp-nativeForm__error {
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 12px;
  background: #fff1f2;
  color: #b42318;
  font-weight: 800;
}

.spp-nativeForm__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
}

.spp-tokenResult {
  display: grid;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  background: #f8fbff;
}

.spp-tokenResult__field {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.spp-tokenResult__field span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.spp-tokenResult__field code {
  display: block;
  padding: 8px 10px;
  border: 1px dashed #c5dbff;
  border-radius: 10px;
  background: #ffffff;
  color: #0f172a;
  white-space: normal;
  overflow-wrap: anywhere;
}

.spp-deleteSummary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  padding: 12px;
  border: 1px solid #fecaca;
  border-radius: 14px;
  background: #fff1f2;
  color: #991b1b;
}

.spp-deleteSummary > svg {
  margin-top: 2px;
}

.spp-deleteSummary > div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.spp-deleteSummary strong,
.spp-deleteSummary span {
  overflow-wrap: anywhere;
}

.spp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  min-height: 42px;
  padding: 0.75rem 1.3rem;
  border-radius: 14px;
  border: 0;
  font-weight: 800;
  cursor: pointer;
}

.spp-btn--primary {
  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);
  color: #ffffff;
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.3);
}

.spp-btn--secondary {
  background: #f8fbff;
  color: #1d4ed8;
  border: 1px solid #dbe8ff;
}

.spp-btn--danger {
  background: linear-gradient(120deg, #b42318 0%, #dc2626 100%);
  color: #ffffff;
  box-shadow: 0 12px 26px rgba(180, 35, 24, 0.24);
}

.spp-btn--primary:disabled,
.spp-btn--secondary:disabled,
.spp-btn--danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spp-modal__loading {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: grid;
  place-items: center;
  color: var(--muted);
  font-weight: 800;
  background: #ffffff;
}

@media (max-width: 1100px) {
  .spp-contentGrid {
    grid-template-columns: 1fr;
  }

  .spp-contentGrid .spp-section:nth-child(3) {
    grid-column: auto;
  }
}

@media (max-width: 720px) {
  .solid-pod-provider__header,
  .spp-account-card__title,
  .spp-section__head {
    align-items: stretch;
    flex-direction: column;
  }

  .solid-pod-provider__header .primary-actions {
    flex-wrap: wrap;
  }

  .spp-shell {
    padding: 14px;
  }

  .spp-account-card__title h2 {
    font-size: 24px;
  }

  .spp-login__grid,
  .spp-overview {
    grid-template-columns: 1fr;
  }

  .spp-action {
    width: 100%;
  }

  .spp-modalOverlay {
    padding: 10px;
  }

  .spp-modal {
    height: calc(var(--dataspace-scaled-vh, 100vh) - 20px);
  }

  .spp-modal--native {
    height: auto;
  }

  .spp-nativeForm__actions {
    align-items: stretch;
    flex-direction: column;
  }

  .spp-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SolidPodProvider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sEAAsE;EACtE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kEAAkE;EAClE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".solid-pod-provider {\n  position: relative;\n  width: 100%;\n  min-height: auto;\n  padding-bottom: 0;\n}\n\n.solid-pod-provider__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.spp-shell {\n  width: 100%;\n  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 230px);\n  padding: 18px;\n  background: #ffffff;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n}\n\n.spp-account-card {\n  width: 100%;\n  max-width: none;\n  display: grid;\n  gap: 22px;\n}\n\n.spp-account-card__title {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--border);\n}\n\n.spp-account-card__title h2 {\n  margin: 0;\n  font-size: 22px;\n  line-height: 1.15;\n  color: var(--text);\n}\n\n.spp-action,\n.spp-iconBtn,\n.spp-deleteIconBtn,\n.spp-btn {\n  font: inherit;\n}\n\n.spp-status,\n.spp-empty {\n  color: var(--muted);\n  font-weight: 800;\n}\n\n.spp-empty {\n  min-height: 96px;\n  display: grid;\n  place-items: center;\n  border: 1px dashed #cbd5e1;\n  border-radius: 14px;\n  background: #f8fafc;\n}\n\n.spp-warning {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 12px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid #fed7aa;\n  background: #fff7ed;\n  color: #9a3412;\n}\n\n.spp-warning--subtle {\n  border-color: #dbeafe;\n  background: #f8fbff;\n  color: #475569;\n}\n\n.spp-warning svg {\n  margin-top: 2px;\n}\n\n.spp-warning div {\n  display: grid;\n  gap: 5px;\n}\n\n.spp-warning strong {\n  color: #7c2d12;\n}\n\n.spp-warning--subtle strong {\n  color: #334155;\n}\n\n.spp-login {\n  display: grid;\n  gap: 14px;\n  padding: 18px;\n  border: 1px solid #dbeafe;\n  border-radius: 14px;\n  background: #f8fbff;\n}\n\n.spp-login__head h3 {\n  margin: 0;\n  color: var(--text);\n  font-size: 20px;\n  line-height: 1.2;\n}\n\n.spp-login__head p {\n  margin: 7px 0 0;\n  color: var(--muted);\n}\n\n.spp-login__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 280px));\n  gap: 12px;\n}\n\n.spp-login__grid label {\n  display: grid;\n  gap: 5px;\n}\n\n.spp-login__grid label > span {\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.spp-login input[type=\"email\"],\n.spp-login input[type=\"password\"] {\n  width: 100%;\n  min-width: 0;\n  padding: 10px 12px;\n  color: var(--text);\n  background: #ffffff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  outline: none;\n}\n\n.spp-login input[type=\"email\"]:focus,\n.spp-login input[type=\"password\"]:focus {\n  border-color: #b9d4ff;\n  box-shadow: 0 0 0 4px var(--ring);\n}\n\n.spp-login__check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #475569;\n  font-weight: 700;\n}\n\n.spp-login__check input {\n  accent-color: var(--primary);\n}\n\n.spp-login__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.spp-login__error {\n  color: var(--danger);\n  font-weight: 800;\n}\n\n.spp-login__note {\n  color: #475569;\n  font-weight: 700;\n}\n\n.spp-overview {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.spp-metric {\n  min-width: 0;\n  min-height: 104px;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  grid-template-rows: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 8px 12px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #f8fbff;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);\n}\n\n.spp-metric svg {\n  grid-column: 1;\n  grid-row: 1;\n  width: 22px;\n  height: 22px;\n  color: var(--primary);\n}\n\n.spp-metric span {\n  grid-column: 2;\n  grid-row: 1;\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.spp-metric strong {\n  grid-column: 1 / -1;\n  grid-row: 2;\n  color: var(--text);\n  font-size: 28px;\n  line-height: 1;\n}\n\n.spp-contentGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.08fr) minmax(0, 1fr);\n  gap: 28px 24px;\n  align-items: stretch;\n}\n\n.spp-contentGrid .spp-section:nth-child(3) {\n  grid-column: 1 / -1;\n}\n\n.spp-section {\n  min-width: 0;\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr);\n  align-content: start;\n  gap: 14px;\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  background: var(--card);\n}\n\n.spp-section__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  min-height: 50px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.spp-section__titleBlock {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.spp-section__icon {\n  flex: 0 0 auto;\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  background: #eaf2ff;\n  color: var(--primary);\n}\n\n.spp-section h3 {\n  margin: 0;\n  color: var(--text);\n  font-size: 20px;\n  line-height: 1.2;\n}\n\n.spp-section p {\n  margin: 4px 0 0;\n  color: var(--muted);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.spp-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 8px 12px;\n  border: 1px solid #dbe8ff;\n  border-radius: 14px;\n  background: var(--primary-ghost);\n  color: var(--primary);\n  white-space: nowrap;\n  font-size: 0.9rem;\n  font-weight: 800;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.spp-action:hover {\n  background: #dbeafe;\n}\n\n.spp-list {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n}\n\n.spp-list li {\n  min-width: 0;\n  display: flex;\n}\n\n.spp-list li > * {\n  width: 100%;\n}\n\n.spp-item {\n  position: relative;\n  min-width: 0;\n  min-height: 142px;\n  display: grid;\n  align-content: start;\n  gap: 13px;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);\n}\n\n.spp-item--token {\n  min-height: 166px;\n  padding-right: 58px;\n}\n\n.spp-item__main {\n  min-width: 0;\n  display: grid;\n  gap: 5px;\n}\n\n.spp-item__label,\n.spp-owner-list > span:first-child {\n  color: var(--muted);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.spp-item strong {\n  min-width: 0;\n  color: var(--text);\n  overflow-wrap: anywhere;\n}\n\n.spp-inlineLink {\n  width: 100%;\n  min-width: 0;\n  display: block;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--primary);\n  font: inherit;\n  font-weight: 800;\n  line-height: 1.35;\n  text-align: left;\n  cursor: pointer;\n  overflow-wrap: anywhere;\n}\n\n.spp-inlineLink:hover {\n  text-decoration: underline;\n}\n\n.spp-owner-list {\n  min-width: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.spp-owner {\n  color: #0f766e;\n  font-size: 0.9rem;\n}\n\n.spp-deleteIconBtn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  background: #fff1f2;\n  color: var(--danger);\n  cursor: pointer;\n}\n\n.spp-deleteIconBtn:hover {\n  background: #fee2e2;\n}\n\n.spp-modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: grid;\n  place-items: center;\n  padding: 22px;\n  background: rgba(15, 23, 42, 0.46);\n  backdrop-filter: blur(8px);\n}\n\n.spp-modal {\n  background: #ffffff;\n  border: 1px solid #dbe3f3;\n  border-radius: 24px;\n  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.3);\n  overflow: hidden;\n}\n\n.spp-modal--external {\n  width: min(1180px, 100%);\n  height: min(820px, calc(var(--dataspace-scaled-vh, 100vh) - 80px));\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr);\n}\n\n.spp-modal--native {\n  width: min(560px, 96vw);\n  max-height: min(720px, 92vh);\n  overflow: auto;\n}\n\n.spp-modal__head {\n  min-width: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 20px 22px;\n  color: #ffffff;\n  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 55%, #1d4ed8 100%);\n}\n\n.spp-modal__eyebrow {\n  display: block;\n  color: #ffffff;\n  font-size: 0.72rem;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  opacity: 0.86;\n  overflow-wrap: anywhere;\n  text-transform: uppercase;\n}\n\n.spp-modal h2 {\n  margin: 5px 0 0;\n  color: #ffffff;\n  font-size: 22px;\n  line-height: 1.15;\n}\n\n.spp-modal__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spp-iconBtn {\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.spp-iconBtn:hover {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.spp-iconBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.spp-modal__body {\n  position: relative;\n  min-height: 0;\n  background: #f8fafc;\n}\n\n.spp-modal__body iframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n  background: #ffffff;\n}\n\n.spp-nativeForm {\n  display: grid;\n  gap: 14px;\n  padding: 20px 22px 22px;\n}\n\n.spp-nativeForm label {\n  display: grid;\n  gap: 6px;\n}\n\n.spp-nativeForm label > span {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.spp-nativeForm input[type=\"text\"],\n.spp-nativeForm input[type=\"url\"],\n.spp-nativeForm select {\n  width: 100%;\n  min-width: 0;\n  padding: 11px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  outline: none;\n}\n\n.spp-nativeForm input[type=\"text\"]:focus,\n.spp-nativeForm input[type=\"url\"]:focus,\n.spp-nativeForm select:focus {\n  border-color: #b9d4ff;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n.spp-nativeForm select {\n  appearance: none;\n}\n\n.spp-nativeForm__error {\n  padding: 10px 12px;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  background: #fff1f2;\n  color: #b42318;\n  font-weight: 800;\n}\n\n.spp-nativeForm__actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin-top: 2px;\n}\n\n.spp-tokenResult {\n  display: grid;\n  gap: 10px;\n  padding: 11px 12px;\n  border: 1px solid #dbeafe;\n  border-radius: 14px;\n  background: #f8fbff;\n}\n\n.spp-tokenResult__field {\n  min-width: 0;\n  display: grid;\n  gap: 5px;\n}\n\n.spp-tokenResult__field span {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.spp-tokenResult__field code {\n  display: block;\n  padding: 8px 10px;\n  border: 1px dashed #c5dbff;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #0f172a;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.spp-deleteSummary {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #fecaca;\n  border-radius: 14px;\n  background: #fff1f2;\n  color: #991b1b;\n}\n\n.spp-deleteSummary > svg {\n  margin-top: 2px;\n}\n\n.spp-deleteSummary > div {\n  min-width: 0;\n  display: grid;\n  gap: 4px;\n}\n\n.spp-deleteSummary strong,\n.spp-deleteSummary span {\n  overflow-wrap: anywhere;\n}\n\n.spp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  min-height: 42px;\n  padding: 0.75rem 1.3rem;\n  border-radius: 14px;\n  border: 0;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.spp-btn--primary {\n  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);\n  color: #ffffff;\n  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.3);\n}\n\n.spp-btn--secondary {\n  background: #f8fbff;\n  color: #1d4ed8;\n  border: 1px solid #dbe8ff;\n}\n\n.spp-btn--danger {\n  background: linear-gradient(120deg, #b42318 0%, #dc2626 100%);\n  color: #ffffff;\n  box-shadow: 0 12px 26px rgba(180, 35, 24, 0.24);\n}\n\n.spp-btn--primary:disabled,\n.spp-btn--secondary:disabled,\n.spp-btn--danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.spp-modal__loading {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  color: var(--muted);\n  font-weight: 800;\n  background: #ffffff;\n}\n\n@media (max-width: 1100px) {\n  .spp-contentGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .spp-contentGrid .spp-section:nth-child(3) {\n    grid-column: auto;\n  }\n}\n\n@media (max-width: 720px) {\n  .solid-pod-provider__header,\n  .spp-account-card__title,\n  .spp-section__head {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .solid-pod-provider__header .primary-actions {\n    flex-wrap: wrap;\n  }\n\n  .spp-shell {\n    padding: 14px;\n  }\n\n  .spp-account-card__title h2 {\n    font-size: 24px;\n  }\n\n  .spp-login__grid,\n  .spp-overview {\n    grid-template-columns: 1fr;\n  }\n\n  .spp-action {\n    width: 100%;\n  }\n\n  .spp-modalOverlay {\n    padding: 10px;\n  }\n\n  .spp-modal {\n    height: calc(var(--dataspace-scaled-vh, 100vh) - 20px);\n  }\n\n  .spp-modal--native {\n    height: auto;\n  }\n\n  .spp-nativeForm__actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .spp-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
